import { createSvgIcon } from '@mui/material/utils'

const Circle = createSvgIcon(
  <>
    <circle cx="3.99964" cy="3.72864" r="3.16901" stroke="#204ECF" strokeWidth="0.704225" />
  </>,
  'Circle'
)

export default Circle
